<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>Non-Teaching Staff Detail</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Faculty Detail</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="">
    <div class="container">
        <div class="section-heading">
            <span class="sub-title">Non-Teaching Staff Details</span>
            <h2 class="mb-9 display-16 display-sm-14 display-lg-10 font-weight-800">OUR STAFF</h2>
            <div class="heading-seperator"><span></span></div>
        </div>

        <table class="table table-responsive table-stripped table-bordered text-center">
            <thead style="background-color: #e67e22;color: white;">
            <tr>
                <th class="bg-secondary text-white text-center" style="width: 20%;">Staff Name</th>
                <th class="bg-secondary text-white text-center" style="width: 40%;">Department</th>
                <th class="bg-secondary text-white text-center" style="width: 40%;">Designation</th>
            </tr>
            </thead>
            <tbody style="background: aliceblue;color:black; font-weight: bold;">
            <tr>
                <td class=" tx-medium tx-inverse">AJAY KUMAR</td>
                <td class=" tx-medium tx-inverse">ACCOUNTS</td>
                <td class=" tx-medium tx-inverse">SENIOR ACCOUNTANT</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">INDU BALA</td>
                <td class=" tx-medium tx-inverse">ACCOUNTS</td>
                <td class=" tx-medium tx-inverse">ACCOUNTS ASSISTANT</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">MEENAKSHI DEVI</td>
                <td class=" tx-medium tx-inverse">ACCOUNTS</td>
                <td class=" tx-medium tx-inverse">ACCOUNTS ASSISTANT</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">AMIT SHARMA</td>
                <td class=" tx-medium tx-inverse">ADMIN BLOCK</td>
                <td class=" tx-medium tx-inverse">CAMPUS OFFICER</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">NARINDER KUMAR</td>
                <td class=" tx-medium tx-inverse">ADMINSTRATION</td>
                <td class=" tx-medium tx-inverse">ASSISTANT REGISTRAR (ADMINSTRATION)</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">NEHA KUMARI</td>
                <td class=" tx-medium tx-inverse">ADMISSION CELL</td>
                <td class=" tx-medium tx-inverse">ADMISSIONS</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">RACHIT CHAUDHARY</td>
                <td class=" tx-medium tx-inverse">ADMISSION CELL</td>
                <td class=" tx-medium tx-inverse">MARKETING EXECUTIVE</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">SHRUTI SHARMA</td>
                <td class=" tx-medium tx-inverse">ADMISSION CELL</td>
                <td class=" tx-medium tx-inverse">STUDENTS SERVICE COORDINATOR</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">SOHAN LAL</td>
                <td class=" tx-medium tx-inverse">ADMISSION CELL</td>
                <td class=" tx-medium tx-inverse">ASSISTANT REGISTRAR (ADMISSION)</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">VIKRAM SINGH</td>
                <td class=" tx-medium tx-inverse">ADMISSION CELL</td>
                <td class=" tx-medium tx-inverse">ADMISSION ASSOCIATE</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">SUMAN DEVI</td>
                <td class=" tx-medium tx-inverse">DEAN ACADEMICS OFFICE</td>
                <td class=" tx-medium tx-inverse">OFFICE ASSISTANT</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">VISHAL SHARMA</td>
                <td class=" tx-medium tx-inverse">EPF</td>
                <td class=" tx-medium tx-inverse">LAISION OFFICER</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">DR. JITENDRA KUMAR GUPTA</td>
                <td class=" tx-medium tx-inverse">EXAMINATION</td>
                <td class=" tx-medium tx-inverse">CONTROLLER OF EXAMINATION</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">GULSHAN MANHAS</td>
                <td class=" tx-medium tx-inverse">EXAMINATION</td>
                <td class=" tx-medium tx-inverse">ASSISTANT TO COE</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">NEELAM DEVI</td>
                <td class=" tx-medium tx-inverse">EXAMINATION</td>
                <td class=" tx-medium tx-inverse">CLERK</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">MEENU</td>
                <td class=" tx-medium tx-inverse">GIRLS HOSTEL</td>
                <td class=" tx-medium tx-inverse">HOSTEL WARDEN</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">MAYANK SHARMA</td>
                <td class=" tx-medium tx-inverse">HOSPITALITY &amp; FACILITY</td>
                <td class=" tx-medium tx-inverse">FOOD &amp; BEVERAGE MANAGER</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">SHOBHIT DASS</td>
                <td class=" tx-medium tx-inverse">HOSTEL</td>
                <td class=" tx-medium tx-inverse">CHIEF WARDEN</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">GEETA KUMARI</td>
                <td class=" tx-medium tx-inverse">HR DEPARTMENT</td>
                <td class=" tx-medium tx-inverse">ASSISTANT REGISTRAR (HR)</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">MUKUL GAHLAUT</td>
                <td class=" tx-medium tx-inverse">INFORMATION TECHNOLOGY</td>
                <td class=" tx-medium tx-inverse">ERP DEVELOPER</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">YOGESH KALOTRA</td>
                <td class=" tx-medium tx-inverse">INFORMATION TECHNOLOGY</td>
                <td class=" tx-medium tx-inverse">IT TECHNICIAN</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">REKHA SHUKLA</td>
                <td class=" tx-medium tx-inverse">LEGAL /LAISION</td>
                <td class=" tx-medium tx-inverse">LEGAL ADVISOR</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">AMIT KUMAR</td>
                <td class=" tx-medium tx-inverse">LIBRARY</td>
                <td class=" tx-medium tx-inverse">LIBRARIAN</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">RASHMI DEVI</td>
                <td class=" tx-medium tx-inverse">LIBRARY</td>
                <td class=" tx-medium tx-inverse">BOOK RESTORER</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">REENA KUMARI</td>
                <td class=" tx-medium tx-inverse">LIBRARY</td>
                <td class=" tx-medium tx-inverse">ASSISTANT LIBRARAIN</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">SARABJEET SINGH</td>
                <td class=" tx-medium tx-inverse">LIBRARY</td>
                <td class=" tx-medium tx-inverse">ASSISTANT LIBRARAIN</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">ABHAY</td>
                <td class=" tx-medium tx-inverse">MARKETING</td>
                <td class=" tx-medium tx-inverse">MARKETING EXECUTIVE</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">ASEEM KUMAR</td>
                <td class=" tx-medium tx-inverse">MARKETING</td>
                <td class=" tx-medium tx-inverse">DIRECTOR- ADMISSION</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">NISHANT CHAUDHARY</td>
                <td class=" tx-medium tx-inverse">PURCHASING</td>
                <td class=" tx-medium tx-inverse">PURCHASE OFFICER</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">DIVYE KUMAR AGRAWAL</td>
                <td class=" tx-medium tx-inverse">REGISTRAR OFFICE</td>
                <td class=" tx-medium tx-inverse">ASSISTANT REGISTRAR (ADMINSTRATION)</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">MONIKA KUMARI</td>
                <td class=" tx-medium tx-inverse">REGISTRAR OFFICE</td>
                <td class=" tx-medium tx-inverse">ASSISTANT REGISTRAR (OPERATIONS)</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">TRILOCHAN SINGH</td>
                <td class=" tx-medium tx-inverse">REGISTRAR OFFICE</td>
                <td class=" tx-medium tx-inverse">DEPUTY REGISTRAR</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">BALVINDRA SINGH</td>
                <td class=" tx-medium tx-inverse">SCHOLARSHIP</td>
                <td class=" tx-medium tx-inverse">COMPUTER OPERATOR</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">ROHIT PATHANIA</td>
                <td class=" tx-medium tx-inverse">SCHOLARSHIP</td>
                <td class=" tx-medium tx-inverse">ACADEMIC ASSOCIATE</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">AMAN KUMAR</td>
                <td class=" tx-medium tx-inverse">STORE</td>
                <td class=" tx-medium tx-inverse">STORE KEEPER</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">MANJIT KUMAR</td>
                <td class=" tx-medium tx-inverse">STORE</td>
                <td class=" tx-medium tx-inverse">STORE INCHARGE</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">BHUPINDER SINGH</td>
                <td class=" tx-medium tx-inverse">TECHNICAL</td>
                <td class=" tx-medium tx-inverse">LAB INSTRUCTOR</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">RAJINDER SINGH</td>
                <td class=" tx-medium tx-inverse">TECHNICAL</td>
                <td class=" tx-medium tx-inverse">WORKSHP INSTRUCTOR</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">RAHUL KUMAR</td>
                <td class=" tx-medium tx-inverse">TRANSPORT</td>
                <td class=" tx-medium tx-inverse">ASSISTANT TRANSPORT INCHARGE</td>
            </tr>
            <tr>
                <td class=" tx-medium tx-inverse">SALWAN</td>
                <td class=" tx-medium tx-inverse">TRANSPORT</td>
                <td class=" tx-medium tx-inverse">INCHARGE</td>
            </tr>
            </tbody>
        </table>
    </div>
</section>
